import React from 'react';
import { Link } from 'react-router-dom';
import styles from './RatedTools.module.css';

const RatedTools = () => {
  const tools = [
    {
      id: 1,
      name: 'Rated',
      description: 'Back to Home',
      link: '/',
      icon: '🏠'
    },
    {
      id: 2,
      name: 'UK House Finder',
      description: 'Find your perfect home',
      link: '/houses',
      icon: '🏘️'
    },
    {
      id: 3,
      name: 'UK Schools Search',
      description: 'Find and compare schools across the UK',
      link: '/schools',
      icon: '🎓'
    },
    // Add more tools here as needed
  ];

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Rated Tools</h1>
      <p className={styles.subtitle}>A collection of useful services and mini-websites</p>
      
      <div className={styles.toolsGrid}>
        {tools.map((tool) => (
          <Link to={tool.link} key={tool.id} className={styles.toolCard}>
            <div className={styles.toolIcon}>{tool.icon}</div>
            <h2 className={styles.toolName}>{tool.name}</h2>
            <p className={styles.toolDescription}>{tool.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RatedTools;
